// extracted by mini-css-extract-plugin
module.exports = {"Title":"WidgetsPage_Title__nI7Sm","WidgetMainBox":"WidgetsPage_WidgetMainBox__2FgFy","HeaderBox":"WidgetsPage_HeaderBox__2VWAa"};